var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-base',{attrs:{"modules":_vm.modules,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }